import { IconFile, IconSpinner } from '../Icons';
import Logic from './logic';

export default function Attachment({ onComplete, value, name, accept, disabled }) {
  const { handleChange, handleClick, hiddenFileInput, loading } = Logic(onComplete);
  return (
    <>
      <div
        {...(!disabled && { onClick: handleClick })}
        className={`text-xs px-3 h-12 bg-white  
        ${disabled && 'cursor-not-allowed '}
         rounded-xl text-slate-500 col-start-1 col-end-2 row-start-1 row-end-2 flex items-center relative z-1 cursor-pointer `}>
        {!loading ? (
          <>
            <div>
              <span className="w-10 flex items-center justify-center h-10 fill-slate-400 rounded-full bg-slate-200 scale-75">
                <IconFile />
              </span>
            </div>
            <input
              type="file"
              name={name}
              ref={hiddenFileInput}
              accept={accept}
              onChange={handleChange}
              style={{ display: 'none' }}
              disabled={disabled}
            />
          </>
        ) : (
          <span className="scale-75">
            <IconSpinner />
          </span>
        )}

        <span className="text-xs mr-3 text-slate-500 uppercase">{value?.name}</span>
      </div>
    </>
  );
}
